// Colour/label presets for notes. `key` is stored on the note; null = no label.
export const NOTE_COLORS = [
  { key: null, label: 'No label', dot: '#cbd5e1', bar: 'transparent' },
  { key: 'amber', label: 'Reminder', dot: '#f59e0b', bar: '#f59e0b' },
  { key: 'rose', label: 'Quote to chase', dot: '#e11d48', bar: '#e11d48' },
  { key: 'blue', label: 'Site note', dot: '#2563eb', bar: '#2563eb' },
  { key: 'green', label: 'Paid / done', dot: '#16a34a', bar: '#16a34a' },
  { key: 'violet', label: 'Idea', dot: '#7c3aed', bar: '#7c3aed' },
  { key: 'red', label: 'Urgent', dot: '#dc2626', bar: '#dc2626' },
];

export const colorOf = (key) => NOTE_COLORS.find((c) => c.key === (key ?? null)) || NOTE_COLORS[0];
